module.exports = __webpack_public_path__ + "img/bmp.7f1266b4.svg";